(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-boxes"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Prevent double-init if both gift-hero and gift-boxes load on same page */
  if (window._giftBoxRevealInit) return;
  window._giftBoxRevealInit = true;

  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('.gift-card__reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function initReveal() {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.gift-card__reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Skip animation in Shopify editor so content is always visible */
  if (window.Shopify && window.Shopify.designMode) {
    document.querySelectorAll('.gift-hero__reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function initReveal() {
    var els = document.querySelectorAll('.gift-hero__reveal');
    if (!els.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-campaign"] && !Shopify.designMode) return;
  try {
    
(function () {
  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (error) {
        reject(error);
      }
      document.body.removeChild(textarea);
    });
  }

  function initPromoCampaign(section) {
    section.querySelectorAll('[data-promo-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var status = section.querySelector('[data-promo-copy-status]');
        var copyTextLabel = button.querySelector('[data-promo-copy-text]');
        var originalLabel = copyTextLabel.textContent;

        copyText(button.dataset.promoCode).then(function () {
          copyTextLabel.textContent = 'Copied!';
          status.textContent = 'Promo code copied to clipboard.';
          window.setTimeout(function () {
            copyTextLabel.textContent = originalLabel;
            status.textContent = '';
          }, 2500);
        }).catch(function () {
          status.textContent = 'Please copy the code manually: ' + button.dataset.promoCode;
        });
      });
    });

  }

  function initAll() {
    document.querySelectorAll('[data-promo-campaign]').forEach(initPromoCampaign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-promo-campaign]');
    if (section) initPromoCampaign(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-knose"]) return;
  try {
    
(function () {
  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var t = document.createElement('textarea');
      t.value = value; t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(t);
    });
  }

  function init(root) {
    if (root.__kpInit) return;
    var dataEl = root.querySelector('[data-kp-data]');
    if (!dataEl) return;
    root.__kpInit = true;

    var data = JSON.parse(dataEl.textContent);
    var colours = data.colours || [];
    var pct = parseFloat(root.dataset.pct) || 20;
    var cur = root.dataset.cur || 'RM';
    var code = root.dataset.code;
    var prop = root.dataset.prop || 'Engraving';
    var tpo = root.dataset.tpo;
    var foils = (root.dataset.foils || 'Gold,Silver,Plain').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var NONE = 'No Engraving';

    function norm(v) { return String(v || '').replace(/\s*\(NEW!\)/i, '').replace(/\s*x\d+\s*$/i, '').trim(); }
    var pillBox = root.querySelector('[data-kp-pills]');
    var seen = {}, scentList = [];
    if (colours[0]) colours[0].variants.forEach(function (v) { if (!seen[v.o1]) { seen[v.o1] = 1; scentList.push(v.o1); } });
    scentList.forEach(function (o1) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kp-pill'; b.dataset.kpScent = ''; b.dataset.value = norm(o1); b.dataset.name = norm(o1);
      b.setAttribute('aria-pressed', 'false'); b.textContent = String(o1).replace(/\s*x\d+(?=\s*(\(NEW!\))?\s*$)/i, '').trim();
      pillBox.appendChild(b);
    });
    var scentEls = root.querySelectorAll('[data-kp-scent]');
    var colourEls = root.querySelectorAll('[data-kp-colour]');
    var img = root.querySelector('[data-kp-sku-img]');
    var summary = root.querySelector('[data-kp-summary]');
    var engrave = root.querySelector('[data-kp-engrave]');
    var engraveBox = root.querySelector('[data-kp-engrave-box]');
    var textInput = root.querySelector('[data-kp-text]');
    var foilBox = root.querySelector('[data-kp-foils]');
    var fee = root.querySelector('[data-kp-fee]');
    var was = root.querySelector('[data-kp-was]');
    var now = root.querySelector('[data-kp-now]');
    var qtyInput = root.querySelector('[data-kp-qty-input]');
    var addBtn = root.querySelector('[data-kp-add]');
    var msg = root.querySelector('[data-kp-msg]');

    var firstScent = scentEls.length ? scentEls[0].dataset.value : null;
    var defIdx = 0;
    colours.forEach(function (c, i) { if (c.default) defIdx = i; });
    var st = { scent: firstScent, colour: defIdx, engrave: false, foil: foils[0], qty: 1, photo: 0 };
    var thumbsBox = root.querySelector('[data-kp-thumbs]');
    var galBtns = root.querySelectorAll('[data-kp-gal]');

    function money(cents) { return cur + (cents / 100).toFixed(2); }
    function find(c, o1, o2) {
      for (var i = 0; i < c.variants.length; i++) {
        var v = c.variants[i];
        if (norm(v.o1) === o1 && v.o2 === o2) return v;
      }
      return null;
    }
    function scentName(value) {
      var n = value;
      scentEls.forEach(function (el) { if (el.dataset.value === value) n = el.dataset.name; });
      return n;
    }
    function currentVariant() {
      var c = colours[st.colour];
      return c ? find(c, st.scent, st.engrave ? st.foil : NONE) : null;
    }
    function setMsg(text, ok) { msg.textContent = text || ''; msg.classList.toggle('is-ok', !!ok); }

    foils.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kp-pill'; b.textContent = f; b.dataset.kpFoil = f;
      b.setAttribute('aria-pressed', 'false');
      foilBox.appendChild(b);
    });

    function render() {
      scentEls.forEach(function (el) {
        var on = el.dataset.value === st.scent;
        if (el.classList.contains('kp-pill')) el.setAttribute('aria-pressed', on ? 'true' : 'false');
        else {
          el.classList.toggle('is-selected', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
          var lbl = el.querySelector('[data-kp-state-label]');
          if (lbl) lbl.textContent = on ? 'Selected' : 'Choose scent';
        }
      });
      colourEls.forEach(function (el) { el.setAttribute('aria-pressed', Number(el.dataset.kpColour) === st.colour ? 'true' : 'false'); });
      foilBox.querySelectorAll('[data-kp-foil]').forEach(function (el) { el.setAttribute('aria-pressed', el.dataset.kpFoil === st.foil ? 'true' : 'false'); });
      engraveBox.hidden = !st.engrave;

      var c = colours[st.colour];
      if (c) {
        var imgs = (c.images && c.images.length) ? c.images : [c.image];
        if (st.photo >= imgs.length || st.photo < 0) st.photo = 0;
        img.src = imgs[st.photo]; img.alt = c.label;
        if (thumbsBox.dataset.colour !== String(st.colour)) {
          thumbsBox.dataset.colour = String(st.colour);
          thumbsBox.innerHTML = '';
          (c.thumbs || []).forEach(function (t, i) {
            var tb = document.createElement('button'); tb.type = 'button'; tb.className = 'kp-thumb'; tb.dataset.kpThumb = i;
            tb.setAttribute('aria-label', 'Photo ' + (i + 1));
            var ti = document.createElement('img'); ti.src = t; ti.alt = ''; ti.loading = 'lazy'; ti.width = 72; ti.height = 72;
            tb.appendChild(ti); thumbsBox.appendChild(tb);
          });
        }
        [].forEach.call(thumbsBox.children, function (tb, i) { tb.setAttribute('aria-current', i === st.photo ? 'true' : 'false'); });
        thumbsBox.hidden = imgs.length < 2;
        [].forEach.call(galBtns, function (b) { b.hidden = imgs.length < 2; });
        summary.textContent = c.label + ' + ' + scentName(st.scent);
        var plain = find(c, st.scent, NONE), eng = find(c, st.scent, foils[0]);
        fee.textContent = (plain && eng && eng.price > plain.price) ? 'Embossing adds ' + money(eng.price - plain.price) + ' (before promo).' : '';
      }
      var v = currentVariant();
      if (v) {
        was.textContent = money(v.price);
        now.textContent = money(Math.round(v.price * (100 - pct) / 100));
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Cart' : 'Sold out';
      }
    }

    scentEls.forEach(function (el) {
      el.addEventListener('click', function () { st.scent = el.dataset.value; setMsg(''); render(); });
      el.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && !el.classList.contains('kp-pill')) { e.preventDefault(); el.click(); }
      });
    });
    colourEls.forEach(function (el) {
      el.addEventListener('click', function () { st.colour = Number(el.dataset.kpColour); st.photo = 0; setMsg(''); render(); });
    });
    thumbsBox.addEventListener('click', function (e) {
      var tb = e.target.closest('[data-kp-thumb]');
      if (tb) { st.photo = Number(tb.dataset.kpThumb); render(); }
    });
    [].forEach.call(galBtns, function (b) {
      b.addEventListener('click', function () {
        var n = (colours[st.colour].images || []).length || 1;
        st.photo = (st.photo + Number(b.dataset.kpGal) + n) % n; render();
      });
    });
    foilBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kp-foil]');
      if (b) { st.foil = b.dataset.kpFoil; render(); }
    });
    engrave.addEventListener('change', function () {
      st.engrave = engrave.checked; setMsg('');
      render();
      if (st.engrave) textInput.focus();
    });
    root.querySelectorAll('[data-kp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.qty = Math.max(1, Math.min(20, st.qty + Number(b.dataset.kpQty)));
        qtyInput.value = st.qty;
      });
    });
    qtyInput.addEventListener('change', function () {
      var n = parseInt(qtyInput.value, 10);
      st.qty = isNaN(n) ? 1 : Math.max(1, Math.min(20, n));
      qtyInput.value = st.qty;
    });

    addBtn.addEventListener('click', function () {
      var v = currentVariant();
      if (!v) { setMsg('This combination is unavailable. Please pick another.'); return; }
      var props = {};
      if (st.engrave) {
        var name = textInput.value.trim();
        if (!name) { setMsg('Please enter the name to emboss, or untick name embossing.'); textInput.focus(); return; }
        if (!/^[A-Za-z0-9 ]{1,10}$/.test(name)) { setMsg('Embossing: up to 10 letters or numbers only (no special characters or emojis).'); textInput.focus(); return; }
        props[prop] = name.toUpperCase();
        if (tpo) props['_tpo_add_by'] = tpo;
      }
      addBtn.disabled = true; setMsg('Adding to cart...', true);
      var item = { id: v.id, quantity: st.qty };
      if (st.engrave) item.properties = props;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
        setMsg('Added! Taking you to your cart...', true);
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
      }).catch(function (err) {
        addBtn.disabled = false; setMsg(err.message || 'Something went wrong. Please try again.');
      });
    });

    var copyBtn = root.querySelector('[data-kp-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var status = root.querySelector('[data-kp-copy-status]');
        var label = root.querySelector('[data-kp-copy-text]');
        var orig = label.textContent;
        copyText(copyBtn.dataset.code).then(function () {
          label.textContent = 'Copied!';
          status.textContent = 'Promo code copied to clipboard.';
          setTimeout(function () { label.textContent = orig; status.textContent = ''; }, 2500);
        }).catch(function () { status.textContent = 'Please copy the code manually: ' + copyBtn.dataset.code; });
      });
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-kp-slider]').forEach(function (sl) {
      var track = sl.querySelector('[data-kp-track]');
      var dotsBox = sl.querySelector('[data-kp-dots]');
      var items = track.children;
      var paused = false;
      function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }
      function go(dir) {
        if (dir > 0 && track.scrollLeft >= maxScroll() - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && track.scrollLeft <= 8) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }
      function mark() {
        if (!dotsBox) return;
        var k = Math.round(track.scrollLeft / step());
        if (track.scrollLeft >= maxScroll() - 8) k = dotsBox.children.length - 1;
        [].forEach.call(dotsBox.children, function (d, i) { d.classList.toggle('is-on', i === k); });
      }
      function buildDots() {
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        var n = Math.max(1, Math.round(maxScroll() / step()) + 1);
        for (var i = 0; i < n; i++) {
          var d = document.createElement('button'); d.type = 'button'; d.tabIndex = -1;
          d.addEventListener('click', (function (k) { return function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); }; })(i));
          dotsBox.appendChild(d);
        }
        mark();
      }
      sl.querySelectorAll('[data-kp-slide]').forEach(function (b) {
        b.addEventListener('click', function () { go(Number(b.dataset.kpSlide)); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { sl.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { sl.addEventListener(ev, function () { paused = false; }); });
      sl.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); }, { passive: true });
      if (!reduce) setInterval(function () { if (!paused && !document.hidden && maxScroll() > 0) go(1); }, 3500);
      window.addEventListener('resize', buildDots);
      buildDots();
    });

    render();
  }

  function initAll() { document.querySelectorAll('[data-kp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-kp]');
    if (r) { r.__kpInit = false; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
